import { FC } from 'react';
import Create from 'components/elements/components/Create';

const Screen: FC = () => {
  return (
    <Create
      elementsEntityName="elements"
      segmentIdKey="segment_id"
    />
  );
};

export default Screen;
